<app-data-table
  [data]="documentTypes || []"
  [displayedColumns]="displayedColumns"
  [columns]="columns"
  [actions]="actions"
  [hasPagination]="false"
  [hasHeader]="false"
  >
</app-data-table>
